import { render, staticRenderFns } from "./DataBurgerButton.vue?vue&type=template&id=7cd440c8&scoped=true"
import script from "./DataBurgerButton.vue?vue&type=script&lang=js"
export * from "./DataBurgerButton.vue?vue&type=script&lang=js"
import style0 from "./DataBurgerButton.vue?vue&type=style&index=0&id=7cd440c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd440c8",
  null
  
)

export default component.exports